<template>
    <div>
        <div class="addmember">
            <span class="mbtb">已删除列表</span>
        </div>
        <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
        >
            <div class="members">
                <el-card class="box-card" v-for="(item,index) in list">
                    <div slot="header" class="clearfix">
                        <div>
                            <div class="userinfo">
                                <span>{{item.memberName}}</span>
                                <span v-if="item.sex == 0">未知</span>
                                <span v-if="item.sex == 1">男</span>
                                <span v-if="item.sex == 2">女</span>
                                <span style="font-size: 11px;line-height: 18px">({{item.phone}})</span>
                            </div>
                            <div class="ui-jb">
                                <img src="../../assets/huizhang.png" class="ui-jb-img">
                                <span style="padding-left: 8px">{{item.lvName==null?'未开通':item.lvName}}</span>
                            </div>
                        </div>
                        <el-button class="ui-btn" type="text" @click="toBtn(item,index)">
                            <van-cell is-link @click.stop="toBtn(item,index)"></van-cell>
                        </el-button>
                    </div>
                    <div>
                        <div class="czxf-time">
                            <div class="cx-time">
                                <span class="t" >上次充值</span>
                                <span class="b" >{{item.czTime==null?'暂无':item.czTime}}</span>
                            </div>
                            <div class="cx-time">
                                <span class="t" >上次消费</span>
                                <span class="b" >{{item.xfTime==null?'暂无':item.xfTime}}</span>
                            </div>
                        </div>
                        <div class="czxf-time" style="margin-top: 25px">
                            <div class="je-val">
                                <span class="t">预存余额(元)</span>
                                <span class="b">¥{{item.balance}}</span>
                            </div>
                            <div class="je-val">
                                <span class="t">赠送余额(元)</span>
                                <span class="b">¥{{item.give}}</span>
                            </div>
                            <div class="je-val">
                                <span class="t">红包余额(元)</span>
                                <span class="b">¥0</span>
                            </div>
                        </div>
                    </div>
                </el-card>
            </div>
        </van-list>
        <van-popup v-model="btnShow" position="bottom" closeable lock-scroll overlay style="height: 30%;">
            <div style="margin-top: 50px">
                <span class="cc-btn" style="background-color: #2b94ff;" @click="restoreMember">恢复</span>
                <span class="cc-btn" style="background-color: #ee0a24;" @click="removeMember">彻底删除</span>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import {getCookie} from "../../utils/auth";
    export default {
        components: {},
        data() {
            return {
                title: '客户中心',
                deptId: '',
                token: '',
                money: '',

                btnShow:false,
                mb:{},
                mbIndex:'',

                list: [],
                page: 1,
                loading: false,
                finished: false,
            };
        },
        async created() {
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            this.token = this.fwUser.token
        },
        methods: {
            chushi(){
                this.list = []
                this.page = 1
                this.loading = false
                this.finished = false
                this.onLoad()
            },
            toBtn(item,index){
                this.mb=item
                this.mbIndex=index
                this.btnShow=true
            },
            closeBtn(){
                this.list.splice(this.mbIndex,1)
                this.btnShow=false
            },
            async onLoad() {
                let currentPage = this.page || 1;
                let data = {
                    deptId: this.deptId,
                    currentPage
                }
                let res = await this.$get("/fw/getDelMemberList", data)
                if (res.code == 200) {
                    const count =res.list.length
                    const newList =res.list
                    const list =this.list.concat(newList)
                    if (list.length<30){
                        this.list = this.quchong(list,"id")
                    }else {
                        this.list =list
                    }
                    this.page=this.page+1
                    this.loading = false
                    if (count<10&&count==0){
                        this.finished = true
                    }
                }else {
                    this.finished = true
                }
            },

            async onSearch() {
                if (!this.money) {
                    this.$notify("请输入要搜索的手机号 / 姓名!");
                    return;
                }
                let data = {
                    deptId: this.deptId,
                    name: this.money,
                };
                let res = await this.$get("/fw/getCustomer", data);
                if (res.code == 200) {
                    this.members = res.list;
                }
            },

            async restoreMember(){
                let res = await this.$post('/fw/fwRestoreMember', {id: this.mb.id})
                if (res.code == 200) {
                    this.closeBtn()
                    this.$notify({
                        message: res.message,
                        duration: 1000,
                        background: '#1989fa'
                    });
                } else {
                    this.$notify({
                        message: res.message,
                        duration: 1000,
                        background: 'red'
                    });
                }
            },

            async removeMember(){
                let res = await this.$post('/fw/fwRemoveMember', {id: this.mb.id})
                if (res.code == 200) {
                    this.closeBtn()
                    this.$notify({
                        message: res.message,
                        duration: 1000,
                        background: '#1989fa'
                    });
                } else {
                    this.$notify({
                        message: res.message,
                        duration: 1000,
                        background: 'red'
                    });
                }
            },

            //去重
            quchong(arr, property) {
                const seen = new Set();
                return arr.filter(item => {
                    const key = item[property];
                    return !seen.has(key) && seen.add(key);
                });
            },
            onClickLeft() {
                this.$router.go(-1)
            },
        },
    };
</script>

<style lang="scss" scoped>

    .members {
        display: flex;
        flex-direction: column;
        border-top: #EEEEEE solid 1px;
        padding: 10px;
    }

    .userinfo{
        font-size: 15px;
        font-weight: bold;
        display: flex;
        flex-direction: row;
    }
    .userinfo span{
        margin-right: 10px;
    }
    .ui-btn{
        float: right;
        font-size: 23px;
        height: 30px;
        position: relative;
        top:-55px;
        right: -20px;
        color: #000000;
        font-weight: bold;
    }
    .ui-jb{
        width: 100px;
        background-color: #C18DFC;
        font-size: 10px;
        padding: 2px 8px;
        border-radius: 10px;
        margin-top: 5px;
        display: flex;
        flex-direction: row;
        align-items: center;
        color: #FFFFFF;
    }
    .ui-jb-img{
        width: 25px;
        height: 14px;
    }
    .czxf-time{
        display: flex;
        flex-direction: row;
        margin: 8px;
    }
    .cx-time{
        width: 50%;
    }
    .cx-time .t{
        display: block;
        color: #979797;
        font-size: 13px;
    }
    .cx-time .b{
        display: block;
        font-size: 12px;
        margin-top: 12px;
    }
    .je-val{
        width: 33.3%;
    }
    .je-val .t{
        display: block;
        color: #979797;
        font-size: 13px;
    }
    .je-val .b{
        display: block;
        font-size: 12px;
        margin-top: 12px;
    }

    /deep/ .el-card__header {
        padding: 12px 18px;
        box-sizing: border-box;
    }
    /deep/ .el-card__body {
        padding: 12px 18px;
    }
    /deep/ .van-cell--clickable {
        background-color: transparent; /* 去掉点击时的背景色 */
    }
    /deep/.van-cell:after {
        display: none; /* 去掉点击后的边框 */
    }
   .cc-btn{
       display: block;
       text-align: center;
       font-size: 15px;height: 30px;
       line-height: 30px;
       color: #ffffff;
       margin: 8px 0;
   }
</style>
